import { createAccountUsersAccountsPath } from "src/routes";

type SuccessfulCreateAccountResponse = Record<PropertyKey, never>;
type UnsuccessfulCreateAccountResponse = { errors: Record<string, string[]>; };
type CreateAccountResult = SuccessfulCreateAccountResponse | UnsuccessfulCreateAccountResponse

const createAccount = async (formData: FormData): Promise<CreateAccountResult> => {
  const requestPath = createAccountUsersAccountsPath();
  const result = await fetch(requestPath, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(Object.fromEntries(formData)),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
  });

  if (result.status < 300) {
    return {};
  } else {
    return await result.json() as CreateAccountResult;
  }
}

export { createAccount, CreateAccountResult }
